/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* AttachExcludedAddressesRequest attaches an org-owned exclusion file to a subscription (when subscription_id is set) or to a pixel (when only pixel_id is set). org_id is supplied as a query param by pixel's REST handler.
*/
export class V1AttachExcludedAddressesRequest {
    'orgId'?: string;
    'fileId'?: string;
    'pixelId'?: string;
    'subscriptionId'?: string;
    /**
    * \"subscription\" or \"pixel\" — required; selects the attach level explicitly so a forgotten subscription_id can never become a pixel-wide attach.
    */
    'attachmentType'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "fileId",
            "baseName": "file_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "pixelId",
            "baseName": "pixel_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "subscriptionId",
            "baseName": "subscription_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "attachmentType",
            "baseName": "attachment_type",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1AttachExcludedAddressesRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

